import { FC } from "react";
import styled from "@emotion/styled";
import { motion } from "framer-motion";

const StyledOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${({ theme }) => theme.zIndex.overlay};

  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.effects.overlay.black_25};
`;

interface Props {
  isOpen: boolean;
  onClick?: () => void;
}

const Overlay: FC<Props> = ({ isOpen, onClick }) =>
  isOpen ? (
    <StyledOverlay
      key="overlay"
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.225, ease: "easeInOut" }}
      onClick={onClick}
    />
  ) : null;

export { Overlay };
